import { ConfigRoutes } from '@shared/models/general/utils.interface';

interface AccesosImportaciones {
    REQUERIMIENTO_COMPRA: ConfigRoutes
    REQUERIMIENTO_COMPRA_REGISTRO: ConfigRoutes
    REQUERIMIENTO_COMPRA_MODIFICAR: ConfigRoutes
    ORDEN_COMPRA: ConfigRoutes
    ORDEN_COMPRA_REGISTRO: ConfigRoutes
    ORDEN_COMPRA_MODIFICAR: ConfigRoutes
    DOCUMENTO_IMPORTACION: ConfigRoutes
    DOCUMENTO_IMPORTACION_REGISTRO: ConfigRoutes
    DOCUMENTO_IMPORTACION_MODIFICAR: ConfigRoutes
    GUIA_INTERNA: ConfigRoutes
    GUIA_INTERNA_REGISTRO: ConfigRoutes
    COSTEO_IMPORTACIONES: ConfigRoutes
    REPORTES: ConfigRoutes
    REPORTE_SEGUIMIENTO_ORDEN_COMPRA: ConfigRoutes
    REPORTE_SEGUIMIENTO_IMPORTACION: ConfigRoutes
    REPORTE_SEGUIMIENTO_PAGO_IMPORTACION: ConfigRoutes
}

interface ModuloImportaciones {
    ID: number
    ACCESOS: AccesosImportaciones
}

const pathModulo = '/importaciones/'

export const MODULO_IMPORTACIONES: ModuloImportaciones = {
    ID: 29,
    ACCESOS: {
        REQUERIMIENTO_COMPRA: {
            TITLE: 'Req. de compra',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de requerimiento de compra de importación',
            ROUTE: 'requerimiento-compra'
        },
        REQUERIMIENTO_COMPRA_REGISTRO: {
            TITLE: 'Requerimiento de compra de importación',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            ROUTE: 'requerimiento-compra/nuevo'
        },
        REQUERIMIENTO_COMPRA_MODIFICAR: {
            TITLE: 'Requerimiento de compra de importación',
            ACCESS: 201,
            PATH_MODULE: pathModulo,
            ROUTE: 'requerimiento-compra/modificar'
        },
        ORDEN_COMPRA: {
            TITLE: 'Orden de compra',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de orden de compra de importación',
            ROUTE: 'orden-compra'
        },
        ORDEN_COMPRA_REGISTRO: {
            TITLE: 'Orden de compra de importación',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            ROUTE: 'orden-compra/nuevo'
        },
        ORDEN_COMPRA_MODIFICAR: {
            TITLE: 'Orden de compra de importación',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            ROUTE: 'orden-compra/modificar'
        },
        DOCUMENTO_IMPORTACION: {
            TITLE: 'Doc. de importación',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de documento de importación',
            ROUTE: 'documento-importacion'
        },
        DOCUMENTO_IMPORTACION_REGISTRO: {
            TITLE: 'Documento de importación',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            ROUTE: 'documento-importacion/nuevo'
        },
        DOCUMENTO_IMPORTACION_MODIFICAR: {
            TITLE: 'Documento de importación',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            ROUTE: 'documento-importacion/modificar'
        },
        GUIA_INTERNA: {
            TITLE: 'Guía interna',
            ACCESS: 305,
            PATH_MODULE: pathModulo,
            DESCRI: 'Consulta de guía interna de ingreso por importación',
            ROUTE: 'guia-interna'
        },
        GUIA_INTERNA_REGISTRO: {
            TITLE: 'Guía interna de ingreso por importación',
            ACCESS: 305,
            PATH_MODULE: pathModulo,
            ROUTE: 'guia-interna/nuevo'
        },
        COSTEO_IMPORTACIONES: {
            TITLE: 'Costeo de importaciones',
            ACCESS: 303,
            PATH_MODULE: pathModulo,
            DESCRI: 'Costeo de importaciones',
            ROUTE: 'costeo-importaciones'
        },
        REPORTES: {
            TITLE: 'Reportes',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            DESCRI: 'Reportes de importaciones',
            ROUTE: 'reportes'
        },
        REPORTE_SEGUIMIENTO_ORDEN_COMPRA: {
            TITLE: 'Seguimiento de orden de compra',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            ROUTE: 'reportes/seguimiento-orden-compra'
        },
        REPORTE_SEGUIMIENTO_IMPORTACION: {
            TITLE: 'Seguimiento de importación',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            ROUTE: 'reportes/seguimiento-importacion'
        },
        REPORTE_SEGUIMIENTO_PAGO_IMPORTACION: {
            TITLE: 'Seguimiento de pago de importación',
            ACCESS: 202,
            PATH_MODULE: pathModulo,
            ROUTE: 'reportes/seguimiento-pago-importacion'
        }
    }
}

export const MODULO_IMPORTACIONES_BUSQUEDA = Object.entries(MODULO_IMPORTACIONES.ACCESOS).filter(item => item[1].DESCRI != null)
